import ShippingAddress from './ShippingAddress';
import { withFormik } from 'formik';
import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import { updateOrderShipping } from '../../../../facades/eagle/user';
import { withRouter } from 'react-router';
import { updateOrderDetails } from '../../../data-providers/orders';
import cookieFactory from '../../../../cookieFactory';

const enhance = compose(
  withRouter,
  withState('isEditing', 'setIsEditing', false),
  withHandlers({
    onToggleEdit: props => () => props.setIsEditing(!props.isEditing),
  }),
  withFormik({
    mapPropsToValues: props => ({
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      stateAbbr: '',
      zipcode: '',
    }),
    handleSubmit: (values, formikBag) => {
      updateOrderShipping(values, formikBag.props.match.params.orderNumber)
        .then(response => {
          const shipping = response.body.data.shipping;
          formikBag.setValues({
            firstName: shipping.firstName,
            lastName: shipping.lastName,
            address1: shipping.address1,
            address2: shipping.address2,
            city: shipping.city,
            stateAbbr: shipping.stateAbbr,
            zipcode: shipping.zipcode,
          });
          const newOrders = updateOrderDetails(response, formikBag.props.userOrders);
          formikBag.props.setUserOrders(newOrders);
          formikBag.props.setIsEditing(false);
        });
    },
  }),
  withProps(props => ({
    states: props.states.map(state => ({
      value: state.abbr,
      label: state.name,
    })),
    isEditable: props.order.isOpen && cookieFactory('isAuthenticated').get() === 'true',
  })),
  lifecycle({
    componentDidUpdate(prevProps) {
      const props = this.props;
      if (!prevProps.shipping && props.shipping) {
        props.setValues({
          firstName: props.shipping.firstName,
          lastName: props.shipping.lastName,
          address1: props.shipping.address1,
          address2: props.shipping.address2,
          city: props.shipping.city,
          stateAbbr: props.shipping.stateAbbr,
          zipcode: props.shipping.zipcode,
        });
      }
    },
  }),
);

export default enhance(ShippingAddress);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Shipping/ShippingAddress/index.js